<template>
    <div class="edit-pwd">
        <div class="top">
            <p>个人中心</p>
        </div>
        <div class="content">
            <el-form ref="form" :rules="rules" :model="form" label-width="140px">
                <el-form-item label="账户名：">
                    <el-input disabled v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item prop="oldPwd" label="当前登录密码：">
                    <el-input type="password" placeholder="请输入密码" v-model="form.oldPwd"></el-input>
                </el-form-item>
                <el-form-item prop="newPwd" label="新登录密码：">
                    <el-input type="password" placeholder="8-16位，必须包含数字及字母，大小写均可，支持特殊字符" v-model="form.newPwd"></el-input>
                </el-form-item>
                <el-form-item prop="confirmPwd" label="确认新登录密码：">
                    <el-input type="password" placeholder="请再次输入新密码" v-model="form.confirmPwd"></el-input>
                </el-form-item>
                <el-form-item class="btn">
                    <el-button :disabled="clicked" class="submit" @click="submit" type="primary">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import Api from '@/api'
import { statusCode } from '@/config'
import { setStorageItem, getStorageItem, removeStorageItem } from '@/utils'
import { sm3 } from '@/utils/sm3'

export default {
  name: 'EditPwd',
  data() {
    const checkNewPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('密码不能为空'))
      }
      const reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,16}$/
      if (reg.test(value)) {
        if (value === this.form.oldPwd) {
          return callback(new Error('新密码不得与原密码相同'))
        }
        return callback()
      }
      return callback(new Error('密码格式不正确'))
    }
    const checkConfirmPwd = (rule, value, callback) => {
      if (value === this.form.newPwd) {
        return callback()
      }
      return callback(new Error('两次密码输入不一致'))
    }
    return {
      form: {
        name: '',
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      clicked: false,
      rules: {
        oldPwd: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
        ],
        newPwd: [
          { required: true, validator: checkNewPwd, trigger: 'blur' },
        ],
        confirmPwd: [
          { required: true, validator: checkConfirmPwd, trigger: 'blur' },
        ]
      }
    }
  },
  created() {
    this.form.name = getStorageItem('loginInfo').email
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.clicked = true
          const req = {
            pwd: sm3(this.form.oldPwd),
            newpwd: sm3(this.form.newPwd)
          }
          Api.user.editPwd(req).then((res) => {
            if (res.retCode === statusCode.SUCCESS) {
              this.$message({
                showClose: true,
                message: '密码修改成功，请重新登录',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.$router.push({
                    name: 'login'
                  })
                }
              })
            } else {
              this.$message.closeAll()
              this.$message({
                showClose: true,
                message: res.retMsg,
                type: 'error'
              })
            }
            this.clicked = false
          }).catch(() => {
            this.clicked = false
            this.$message({
              showClose: true,
              message: '服务器错误',
              type: 'error'
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .edit-pwd{
        width: 100%;
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .top{
            width: 100%;
            height: 50px;
            border-bottom: 1px solid #EEEEEE;
            p{
                margin-left: 30px;
                line-height: 50px;
                position: relative;
            }
            p::before{
                position: absolute;
                width: 4px;
                height: 16px;
                background-color: #2455CE;
                content: '';
                top: 17px;
                left: -10px;
            }
        }
        .content{
            width: 100%;
            display: flex;
            justify-content: center;
            .el-form{
                width: 600px;
                margin-top: 50px;
                .btn{
                    text-align: center;
                }
                .submit{
                    background-color: #1D60C0;
                    width: 150px;
                    margin-top: 50px;
                }
            }
        }
    }
</style>
